/**
 * 文件说明:
 *
 * auth layout utils
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {hzLayoutFlatData} from 'umi'
import {pathToRegexp} from 'path-to-regexp'
import {createMemoizeCache} from 'utils'

export function isAuthLayoutPath(hzLayoutPath = '') {
    return hzLayoutPath.endsWith('/src/layouts/auth-layout/register.js')
}

export function getInnerAuthLayoutData(pathname = '') {
    for (const item of hzLayoutFlatData) {
        if (pathToRegexp(item?.routePath).test(pathname) && isAuthLayoutPath(item?.hzLayoutPath)) {
            return item
        }
    }
}

export const getAuthLayoutData = createMemoizeCache({
    isEqual() {
        return true
    },
    getKey(pathname) {
        return pathname
    },
    getDeps() {
        return hzLayoutFlatData
    },
    getVal(pathname) {
        return getInnerAuthLayoutData(pathname)
    },
})
